import React from "react";
import Setting from "../../components/Setting/Setting";

export default function SettingPage() {
  return (
    <div>
      <Setting />
    </div>
  );
}
